import { render } from "./GigaManagerAccess.vue?vue&type=template&id=69b4d947&scoped=true"
import script from "./GigaManagerAccess.vue?vue&type=script&lang=js"
export * from "./GigaManagerAccess.vue?vue&type=script&lang=js"

import "./GigaManagerAccess.vue?vue&type=style&index=0&id=69b4d947&scoped=true&lang=css"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b4d947"]])

export default __exports__